import {
  Alert,
  Box,
  Text,
  WizardStepRenderParams,
  useOnNext,
} from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'
import { ProjectManagementFinancialDetailsFormQuery } from 'generated/resources/graphql'

import { useFormContext } from 'modules/core/hooks/useForm'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import ProjectFinancialDetailsForm from 'modules/project_management/components/forms/ProjectFinancialDetailsForm'
import { UpsellWizardGenericStep } from 'modules/project_management/components/upsells/UpsellWizardGenericStep'
import { ProjectsUpsellRequestSources } from 'modules/project_management/components/upsells/constants'

import { CreateProjectProps } from '../types'

interface Props {
  hasCostsFeature: boolean
  details?: ProjectManagementFinancialDetailsFormQuery
}

export const FinancialDetailsStep = ({
  data,
  details,
  onDataChanged,
  hasCostsFeature,
}: WizardStepRenderParams<CreateProjectProps> & Props) => {
  const form = useFormContext<CreateProjectProps>()

  const handleFieldChanged = (fieldName: string, fieldValue: string | boolean | undefined) => {
    onDataChanged({ ...data, [fieldName]: fieldValue })
  }

  useOnNext(() => {
    track(trackingEvents.projectManagement.wizard.projectFinancialsDetailsProjectWizard, {
      billable: data.isBillable,
      legalEntityId: data.legalEntityId,
      fixedCost: !!data.fixedCost,
    })
  })

  return (
    <Box flexDirection="row" gap="s48">
      <Box flexDirection="column" gap="s24" width="s400">
        <Text.Header2 weight="semibold">
          {i18n.t('project_management.modals.create_project.wizard.financial_step.header')}
        </Text.Header2>
        {hasCostsFeature ? (
          <ProjectFinancialDetailsForm
            onChangeValue={handleFieldChanged}
            values={data}
            data={details}
            errors={form.errors}
            isOwner
          />
        ) : (
          <UpsellWizardGenericStep
            featureRequested={Features.projects_costs}
            requestSource={ProjectsUpsellRequestSources.financialDetailsStep}
          />
        )}
      </Box>
      <Box
        flexDirection="column"
        justifyContent="flexStart"
        maxWidth="s200"
        gap="s8"
        paddingTop="s64"
      >
        <Alert color="info">
          💡 {i18n.t('project_management.modals.create_project.wizard.financial_step.alert')}
        </Alert>
      </Box>
    </Box>
  )
}
